const formatPhoneNumber = (phoneNumber: string): string => {
  const digits = phoneNumber.replace(/\D/g, '');

  return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`;
};

const clearPhoneMask = (phone: string) => {
  if (/\+/g.test(phone)) {
    return phone.substring(1).replace(/\D/g, '');
  }

  return phone.replace(/\D/g, '');
};

export { formatPhoneNumber, clearPhoneMask };
